import { render, staticRenderFns } from "./EventLiveDonation.vue?vue&type=template&id=03b8c95f&scoped=true&"
import script from "./EventLiveDonation.vue?vue&type=script&lang=js&"
export * from "./EventLiveDonation.vue?vue&type=script&lang=js&"
import style0 from "./EventLiveDonation.vue?vue&type=style&index=0&id=03b8c95f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b8c95f",
  null
  
)

export default component.exports